import { render, staticRenderFns } from "./NationalCordinatorReprt.vue?vue&type=template&id=036789a0"
import script from "./NationalCordinatorReprt.vue?vue&type=script&lang=js"
export * from "./NationalCordinatorReprt.vue?vue&type=script&lang=js"
import style0 from "./NationalCordinatorReprt.vue?vue&type=style&index=0&id=036789a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports